import { FormElems } from '..';
import React from 'react';
import PropTypes from 'prop-types';
// Libraries

import { Field, FieldArray } from 'redux-form';
// Card slabs

const renderSurchargeSlab = ({
    fields,
    meta: { error, submitFailed },
    sectionData,
    schemeOptions,
    isViewMode,
    cardCategoriesOptions,
}) => {
    console.log("ok inside the surcharge component", fields,
        schemeOptions,
        isViewMode);
    const defaultcardCategory = "All Card Categories";
    const newAddFieldInitialData = { bankSlabs: sectionData[0].bankSlabs, cardCategory:  defaultcardCategory};
    const selectedSchemes = fields.getAll()?.map(data => data.cardType) || [];
    // eslint-disable-next-line no-param-reassign

    // console.log(newAddFieldInitialData, "newAddFieldInitialData")

    const selectedScheme = index => {
        const data = fields.getAll();
        const selectedCardType = data[index].cardType;
        if (selectedCardType && index !== 0) {
            const selectedOption = schemeOptions.find(
                option => option.value === selectedCardType
            );

            return [selectedOption];
        }
        return [];
    };

    const getSelectedCardCategory = index => {
        const data = fields.getAll();
        const selectedCardCategory = data[index].cardCategory;
        if (selectedCardCategory && index !== 0) {
            const selectedOption = cardCategoriesOptions.find(
                option => option.value === selectedCardCategory
            );

            return [selectedOption];
        }
        return [];
    };


    const getFilteredSchemaOptions = (index) => {
        const cardMap = {};
        const data = fields.getAll();
        const details = data?.forEach((fieldData, fieldDataIndex) => {
            if (fieldData && fieldData.cardType) {
                if (cardMap[fieldData.cardType]) {
                    cardMap[fieldData.cardType] = [...cardMap[fieldData.cardType], fieldData.cardCategory]
                } else {
                    cardMap[fieldData.cardType] = [fieldData.cardCategory]
                }
            }
        })

        // Remove card types if all their categories are selected
        let filteredSchemeOptions = schemeOptions.filter(option => {
            const categories = cardMap[option.value] || [];
            return !cardCategoriesOptions.every(item => categories.includes(item.value));
        });

        return [...selectedScheme(index), ...filteredSchemeOptions].filter(item => Boolean(item));
    }

    const getFilteredCardCategories = (index) => {
        const cardMap = {};
        let data = fields.getAll()
        const details = data.forEach((fieldData, fieldDataIndex) => {
            if (fieldData && fieldData.cardType) {
                if (cardMap[fieldData.cardType]) {
                    cardMap[fieldData.cardType] = [...cardMap[fieldData.cardType], fieldData.cardCategory]
                } else {
                    cardMap[fieldData.cardType] = [fieldData.cardCategory]
                }
            }
        })

        let selectedCardCategoriesForCardType = cardMap[data[index].cardType] || [];

        // Remove card types if all their categories are selected
        let filteredCardCategories = cardCategoriesOptions.filter(option => {
            return !selectedCardCategoriesForCardType.includes(option.value);
        });
        // console.log("options", [...getSelectedCardCategory(index), ...filteredCardCategories]);
        return [...getSelectedCardCategory(index), ...filteredCardCategories];
    }

    const updateCardCategory = (value, index) => {
        let data = fields.getAll();
        
        let cardType = value;


        let arr = data.filter(item => item.cardType == cardType && item.cardCategory == defaultcardCategory);
        let flag = arr.length >= 1;

        if (flag) {
            data[index].cardCategory = "";
        }
    }

    // console.log(fields.getAll(), "FIELDS");

    return (
        <>
            {fields.map((item, index) => (
                <>
                    <div className="bank-wrap">
                        <Field
                            wrapperClass="surcharge-bank"
                            name={`${item}.cardType`}
                            id={`${item}-issuerId`}
                            component={FormElems.Select}
                            data={
                                getFilteredSchemaOptions(index) || []
                            }
                            label={
                                index === 0 ? 'All Schemes' : 'Select Scheme'
                            }
                            labelField="label"
                            valueField="value"
                            disabled={isViewMode || index === 0}
                            borderRadius="5px"
                            onChange={(value) => {updateCardCategory(value, index)}}
                        />
                        <Field
                            wrapperClass="surcharge-bank"
                            name={`${item}.cardCategory`}
                            id={`${item}-cardCategory`}
                            component={FormElems.Select}
                            data={[...new Set(getFilteredCardCategories(index))] || []}
                            label={index === 0 ? 'All' : 'Select Card Category'}
                            labelField="label"
                            valueField="value"
                            disabled={isViewMode || index === 0}
                            borderRadius="5px"
                        />
                        {index > 0 ? (
                            <FormElems.Button
                                customClass="remove-button"
                                buttonType="secondary"
                                id={`remove-${item}-issuerId`}
                                text="x Remove"
                                type="button"
                                isDisable={isViewMode}
                                handleClick={() => fields.remove(index)}
                            />
                        ) : (
                            <FormElems.Button
                                customClass="add-button"
                                buttonType="secondary"
                                id={`add-${item}-issuerId`}
                                text="+ Add Schemes"
                                type="button"
                                isDisable={isViewMode}
                                handleClick={() =>
                                    fields.push({ ...newAddFieldInitialData })
                                }
                            />
                        )}
                    </div>
                    <ul className="slabCard-container border-bottom">
                        <FieldArray
                            name={`${item}.bankSlabs`}
                            component={renderSurchargeSlabItems}
                            schemeOptions={schemeOptions}
                            props={{ sectionData, isViewMode }}
                        />
                    </ul>
                </>
            ))}
        </>
    );
};

// card slabs
const renderSurchargeSlabItems = ({
    fields,
    meta: { error, submitFailed },
    sectionData,
    isViewMode,
}) => {
    // const section = sectionData.length > 0 ? sectionData : [];
    // eslint-disable-next-line react/prop-types
    const section = fields.getAll();
    // if lower slab <=2000 and higherslab is null
    const noSlab = section.find(item => {
        return (
            item.lowerSlab !== null && item.lowerSlab < 2000 && !item.higherSlab
        );
    });

    const cardTitle = title => {
        if (title === 'ESF') {
            return 'SAME DAY SETTLEMENT FEE';
        }

        return title?.replaceAll('_', ' ');
    };

    const tiles = (item, index) => {
        return (
            <li className={!noSlab ? 'cardTile' : ''}>
                <div className="slab-title">
                    <div className="title">
                        {cardTitle(section[index]?.type)}
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Percent</p>
                        <Field
                            name={`${item}.feePercent`}
                            id={`${item}-feePercent`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={4}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Flat</p>
                        <Field
                            name={`${item}.feeFlat`}
                            id={`${item}-feeFlat`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="INR"
                            disabled={isViewMode}
                            maxDecimals={2}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Criteria</p>
                        <Field
                            name={`${item}.feeCriteria`}
                            id={`${item}-feeCriteria`}
                            data={[
                                {
                                    label: 'Minimum',
                                    value: 'MINIMUM',
                                },
                                {
                                    label: 'Maximum',
                                    value: 'MAXIMUM',
                                },
                                {
                                    label: 'Both',
                                    value: 'BOTH',
                                },
                            ]}
                            labelField="label"
                            valueField="value"
                            component={FormElems.Select}
                            label="Criteria"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Tax</p>
                        <Field
                            name={`${item}.tax`}
                            id={`${item}-tax`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={2}
                        />
                    </div>
                </div>
            </li>
        );
    };

    const renderSlabs = () => {
        // get left slabs
        const leftSlab = fields.map((item, index) => {
            if (
                section[index].higherSlab &&
                section[index].higherSlab <= 2000
            ) {
                return tiles(item, index);
            }
        });

        // get right slabs
        const rightSlab = fields.map((item, index) => {
            if (section[index].lowerSlab && section[index].lowerSlab >= 2000) {
                return tiles(item, index);
            }
        });

        return (
            <>
                <ul className="leftSlab-container slabCard-container slab">
                    <div className="slab-heading">Slab - Upto 2000</div>
                    {leftSlab}
                </ul>
                <ul className="rightSlab-container slabCard-container slab">
                    <p className="slab-heading">Slab - Above 2000 </p>
                    {rightSlab}
                </ul>
            </>
        );
    };

    if (noSlab) {
        return fields.map((item, index) => {
            return tiles(item, index);
        });
    }
    return <div style={{ display: 'flex' }}>{renderSlabs()}</div>;
};

renderSurchargeSlab.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    schemeOptions: PropTypes.array,
    cardCategoriesOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
};
renderSurchargeSlabItems.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    schemeOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
};

export default renderSurchargeSlab;
